import { Box, FormControl, FormLabel, Switch } from '@chakra-ui/react';
import NouveauChampionnatForm from 'features/championnats/components/NouveauChampionnatForm';
import NouveauChampionnatPersonnaliseForm from 'features/championnats/components/NouveauChampionnatPersonnaliseForm';
import { RoutePath } from 'router/routes.paths';
import BPCPageHeading from 'common/components/BPCPageHeading';
import { useState } from 'react';

export default function NouveauChampionnatPage() {
  const [isPersonnalise, setIsPersonnalise] = useState(false);

  return (
    <Box>
      <BPCPageHeading
        title="Nouveau championnat"
        breadcrumbItems={[
          { to: RoutePath.home, name: 'Home' },
          { to: RoutePath.championnats, name: 'Championnats' },
        ]}
      />
      <FormControl display="flex" alignItems="center" mb={6}>
        <FormLabel htmlFor="championnat-personnalise" mb="0">
          Championnat personnalisé
        </FormLabel>
        <Switch
          id="championnat-personnalise"
          isChecked={isPersonnalise}
          onChange={(event) => setIsPersonnalise(event.target.checked)}
        />
      </FormControl>
      {isPersonnalise ? (
        <NouveauChampionnatPersonnaliseForm />
      ) : (
        <NouveauChampionnatForm />
      )}
    </Box>
  );
}
